<template>
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-alert type="error" v-if="error != ''">
                <p>{{error}}</p>
            </v-alert>
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Formulario de Registro</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-form @submit.prevent="crearUsuario({email:email, pass:pass1, isla:isla})">
                  <v-text-field
                    label="Email"
                    name="email"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="email"
                  />

                  <v-text-field
                    id="pass1"
                    label="Contraseña"
                    name="pass1"
                    prepend-icon="mdi-key"
                    type="password"
                    v-model="pass1"
                  />
                  <v-text-field
                    id="pass2"
                    label="Repetir Contraseña"
                    name="pass2"
                    prepend-icon="mdi-key"
                    type="password"
                    v-model="pass2"
                  />
                  <v-radio-group v-model="isla" row>
                        <v-radio label="Gran Canaria" value="GC"></v-radio>
                        <v-radio label="Tenerife" value="TF"></v-radio>
                  </v-radio-group>
                   <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" type="submit" :disabled="!desactivar">Registrar</v-btn>
                    </v-card-actions>
                </v-form>
              </v-card-text>
             
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
</template>

<script>
import { mapActions,mapState } from "vuex"
  export default {
    props: {
      source: String,
    },
    data() {
        return {
            email: '',
            pass1: '',
            pass2: '',
            isla: ''
        }
    },
    methods: {
        ...mapActions(['crearUsuario'])
    },
    computed: {
        ...mapState(['error']),
        desactivar(){
            return this.pass1 === this.pass2 && this.pass1 != '' && this.isla != ''
        }
    },
  }
</script>